import config from 'config';
import React, { PropTypes } from 'react';
import Input from 'formComponents/Input';
import ImageUpload from 'formComponents/ImageUpload';
import ErrorContainer from 'formComponents/ErrorContainer';
import FullDatePicker from 'formComponents/FullDatePicker';
import VotingToolBar from './../VotingToolBar';
import VotingBaseForm from '../VotingBaseForm';

class BestPlayerVoting extends VotingBaseForm {
  static propTypes = {
    model: PropTypes.instanceOf(BestPlayerVoting),
    fields: PropTypes.shape({
      start_time: PropTypes.object.isRequired,
      end_time: PropTypes.object.isRequired
    }),
    disabled: PropTypes.bool
  };

  render() {
    let {
      fields: {
        voting,
        file,
        award_location,
        start_time,
        end_time,
        game_description,
      },
      disabled,
      configOptions = {
        options: { moduleDescription: true }
      },
    } = this.props;

    return (
      <div>
        <ErrorContainer id="event_bingo_voting" displayLabel={false} error={voting.error} touched={true} style={{margin:0}}/>
        <ImageUpload label="Bingo image" required
                     imageWidth="auto"
                     imageHeight={80}
                     disabled={disabled}
                     crop={config.voting.imageCrop}
          {...file}/>
        {configOptions.options && configOptions.options.moduleDescription && <Input label="Game description" required disabled={disabled} {...game_description}/>}
        <Input label="Pickup location" required disabled={disabled} {...award_location}/>
        <FullDatePicker label="Start time" required disabled={disabled} {...start_time}/>
        <FullDatePicker label="End time" min={start_time.value} required disabled={disabled} {...end_time}/>

        <VotingToolBar {...this.getToolbarOptions()}/>
      </div>
    );
  }
}

export default BestPlayerVoting;




// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/votings/BingoVoting/BingoVotingForm.jsx